import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  useAvApi,
  PutV2UsersByUserIdResponse,
  PutV2UsersByUserIdBody,
} from '@app-velocity/av-api-v2';
import { useUserData } from '@app-velocity/libs/auth';

export const UPDATE_USER_DATA_MUTATION_KEY = 'users/update-data';

export const useUpdateUserDataMutation = () => {
  const { users } = useAvApi();
  const { userId } = useUserData();
  const queryClient = useQueryClient();

  return useMutation<
    PutV2UsersByUserIdResponse | undefined,
    AxiosError,
    PutV2UsersByUserIdBody
  >({
    mutationKey: [UPDATE_USER_DATA_MUTATION_KEY],
    mutationFn: async (payload: PutV2UsersByUserIdBody) => {
      if (!userId) return;
      const { data } = await users.putV2UsersByUserId(payload, { userId });

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['current-user'],
      });
    },
  });
};
